import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUsers, fetchUserTypes, createUserType } from "../../actions/auth";
import { useSnackbar } from "../../utils/useSnackbar";
import UsersTab from "../../admin/UserManagement/UsersTab";
import { ListPageSkeleton } from "../Skeletons";

// Reuses the store-admin Users table (admin/UserManagement/UsersTab.js) via
// its optional allowAdminActions/showExpiry/excludeUserId props rather than
// duplicating a near-identical table - superAdmin gets the same
// search/paginate/create/edit/delete/reset-password UI, plus the ability
// to toggle admin accounts and set a per-user expiry date.
const SuperAdminUsersTab = () => {
  const dispatch = useDispatch();
  const { users, userTypes, isLoading } = useSelector((state) => state.auth);
  const [openSnackbar] = useSnackbar();

  useEffect(() => {
    dispatch(getUsers());
    dispatch(fetchUserTypes());
  }, [dispatch]);

  if (isLoading) {
    return <ListPageSkeleton columns={6} />;
  }

  // Excludes only the currently signed-in superAdmin's own row - user
  // request, reversing the earlier call to show it (see the old comment this
  // replaced). Any *other* superAdmin account still shows normally, so
  // reveal-password/reset-password/view-profile on a colleague's superAdmin
  // account stays reachable; delete stays blocked for every superAdmin row
  // regardless (see isUserSuperAdmin in UsersTab.js and the server-side guard
  // in deleteUser).
  const ownUserId = JSON.parse(localStorage.getItem("profile") || "null")?.result?._id;

  return (
    <UsersTab
      users={users || []}
      userTypes={userTypes || []}
      onCreateUserType={(data, snackbar) => dispatch(createUserType(data, snackbar))}
      openSnackbar={openSnackbar}
      allowAdminActions
      showExpiry
      canDeleteAdmins
      allowPasswordReveal
      excludeUserId={ownUserId}
    />
  );
};

export default SuperAdminUsersTab;
